import { Controller } from 'react-hook-form';
import { Checkbox } from 'primereact/checkbox';

export default function MultipleChoice({ control, name, options = [], disabled }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const handleChange = (optionValue) => {
          const currentValue = field.value || [];
          const newValue = currentValue.includes(optionValue)
            ? currentValue.filter((v) => v !== optionValue)
            : [...currentValue, optionValue];
          field.onChange(newValue);
        };

        return (
          <div className="d-flex flex-wrap">
            {options.map((option, i) => (
              <div key={option.value} className="d-flex align-items-center w-50 mt-2">
                <Checkbox
                  inputId={`${name}-${i}`}
                  name={name}
                  value={option.value}
                  checked={field.value?.includes(option.value)}
                  onChange={() => handleChange(option.value)}
                  disabled={disabled}
                />
                <label htmlFor={`${name}-${i}`} className="ms-2">
                  {option?.label}
                </label>
              </div>
            ))}
          </div>
        );
      }}
    />
  );
}
